module.exports = __webpack_public_path__ + "static/blue-arrow-down-30959509eea753d6c43951cb7c74fff7.png";